import { API_ROOT } from '../../config/config'
import { doDelete, doGet, doPost, doPutFiles, doDownload, doPut } from './utils'

// const API_ROOT = 'http://localhost:9016/api'
const API_ROOT_VER = `${API_ROOT}/v1/audit/ia`

export const getReportsAudit = (id = '', projectversionId = '') => {
  const url = `${API_ROOT_VER}/get?id=${id}&projectversionId=${projectversionId}`
  return doGet(url)
}

export const saveReportsAudit = (request, id = '', isSaveDraft = false) => {
  const url = `${API_ROOT_VER}/internal-save/${id}?saveDraft=${isSaveDraft}`
  return doPost(url, request)
}

export const sendBackReportsAudit = (request, id = '') => {
  const url = `${API_ROOT_VER}/internal-sendback/${id}`
  return doPost(url, request)
}

export const updateReviewIaAudit = (id = '', request, isSaveDraft = false) => {
  const url = `${API_ROOT_VER}/review/${id}?saveDraft=${isSaveDraft}`
  return doPutFiles(url, request)
}

export const downloadAuditfilesAttachments = (filePath) => {
  const url = `${API_ROOT}/v1/audit/download/file?filePath=${filePath}`
  return doDownload(url)
}

export const getReportsAuditIAP12Attch = (id) => {
  const url = `${API_ROOT_VER}/iap12/attch/${id}`
  return doGet(url)
}

export const saveReportsAuditReviewPass = (request) => {
  const url = `${API_ROOT_VER}/internal-review/pass`
  return doPost(url, request)
}

export const sendBackReviewIAAudit = (request) => {
  const url = `${API_ROOT_VER}/review-sendback`
  return doPut(url, request)
}
